import ListView from '@/components/datagrid/ListView';
import useTitle from '../../../../hooks/useTitle';
import { Delete } from '@mui/icons-material';
import TenantRolesDetail from '@/components/forms/tenants/TenantRolesDetail';
import { useState } from 'react';
import useTenantQuery from '@/hooks/useTenantQuery';
import { PersonAdd } from '@mui/icons-material';
import useLiveData from '@/hooks/useLiveData';
import TenantRolesDialog from '@/components/forms/tenants/TenantRolesDialog';
import useAppStore from '@/store/app';
import useTenantDelete from '@/hooks/useTenantDelete';

const columns = [
  { field: 'name', headerName: 'Name', flex: 0.3 },
  { field: 'description', headerName: 'Beschreibung', flex: 0.4 },
  { field: 'superuser', headerName: 'Admin', flex: 0.3 },
];

export default function Roles() {
  useTitle('Rollen');
  const { isPending, data: roles } = useTenantQuery('role');
  const [sortModel] = useState([{ field: 'name', sort: 'asc' }]);

  const [selectedRows, setSelectedRows] = useState([]);
  const { liveData } = useLiveData('role');

  const { setDialogForm } = useAppStore();

  const { mutateAsync: deleteCallback } = useTenantDelete('role');
  const { selectedItem, setSelectedItem } = useAppStore();


  const handleDelete = () => {
    selectedRows.forEach((id) => {
      if (selectedItem === id) {
        setSelectedItem(null);
      }
      deleteCallback(id);
    });
    setSelectedRows([]);
  };


  const rows = roles?.map((role) => {
    return {
      id: role._id,
      ...role,
    };
  });

  const actions = [
    {
      title: 'Hinzufügen',
      label: 'Hinzufügen',
      icon: PersonAdd,
      variant: 'contained',
      onClick: () => {
        setDialogForm(<TenantRolesDialog />);
      },
      group: 'primary',
    },
    {
      title: 'Löschen',
      label: 'Löschen',
      color: 'error',
      selection: 'multi',
      icon: Delete, onClick: handleDelete
    },
  ];

  return (
    <ListView
      rows={rows}
      columns={columns}
      actions={actions}
      loading={isPending}
      detailComponents={[
        { Component: TenantRolesDetail, title: 'Details', url: '/roles' },
      ]}
      setSelectedRows={setSelectedRows}
      selectedRows={selectedRows}
      livedata={liveData}
      sortModel={sortModel}
    />
  );
}
